import React, {PropsWithChildren, ReactElement, ReactNode} from 'react';
import CollegeEarnings from '../../../high-school-student/college-earnings/components/college-earnings';
import connectCollegeEarnings from '../../../shared/college-earnings/containers/college-earnings';
import {useMediaQuery} from '../../hooks/useMediaQuery';
import styles from './styles.module.scss';
import usePlatformContext from '../../hooks/usePlatform';
import classnames from 'classnames';

const ConnectedCollegeEarnings = connectCollegeEarnings(CollegeEarnings);

type EarningsSidebarLayoutProps = PropsWithChildren<{
  headerComponents?: ReactNode;
  sidebar?: ReactNode;
}>;

const EarningsSidebarLayout = ({
  children,
  headerComponents,
  sidebar,
}: EarningsSidebarLayoutProps): ReactElement => {
  const mq = useMediaQuery();
  const {isIonic} = usePlatformContext();

  return (
    <div
      className={classnames(styles.container, {[styles.fixed]: !isIonic})}
      id="earnings-sidebar-layout-container"
      data-testid="earnings-sidebar-layout"
    >
      {headerComponents ? headerComponents : null}
      <div className={styles.containerBody}>
        <div className="container">
          <div className={styles.body}>
            <div>{children}</div>
          </div>
        </div>
        <div>
          {!isIonic && mq.SM_AND_UP && (
            <div className={styles.sidebar}>
              <div className="portfolio-college-earnings-container">
                {sidebar ? sidebar : <ConnectedCollegeEarnings />}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EarningsSidebarLayout;
